import { render, staticRenderFns } from "./ListTipopessoaPage.vue?vue&type=template&id=f0bb787a"
import script from "./ListTipopessoaPage.vue?vue&type=script&lang=js"
export * from "./ListTipopessoaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports